import React, { useState, useEffect, useContext, useRef } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import RadioGroup from "@mui/material/RadioGroup";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { makeStyles } from "@mui/styles";
import axios from "axios";

import Home1 from "../../assets/homeService1.png";
import Home1Banner from "../../assets/homeService1-banner.png";
import Home1PaddingBanner from "../../assets/homeService1-banner-padding.png";
import Home1Padding from "../../assets/homeService1-padding.png";

import Home4 from "../../assets/homeService2.png";
import Home4Banner from "../../assets/homeService2-banner.png";

import Home5 from "../../assets/homeService3.png";
import Home5Banner from "../../assets/homeService3-banner.png";
import Home5PaddingBanner from "../../assets/homeService3-banner-padding.png";
import Home5Padding from "../../assets/homeService3-padding.png";

import Home6 from "../../assets/homeService4.png";
import Home6Banner from "../../assets/homeService4-banner.png";

import Home7 from "../../assets/homeService5.png";
import Home7Banner from "../../assets/homeService5-banner.png";
import Home7PaddingBanner from "../../assets/homeService5-banner-padding.png";
import Home7Padding from "../../assets/homeService5-padding.png";

import Home8 from "../../assets/homeService6.png";
import Home8Banner from "../../assets/homeService6-banner.png";
import Home8PaddingBanner from "../../assets/homeService6-banner-padding.png";
import Home8Padding from "../../assets/homeService6-padding.png";

import Home2 from "../../assets/homeService2.png";
import Home2Banner from "../../assets/homeService2-banner.png";

import Home3 from "../../assets/homeService7.png";
import Home3Banner from "../../assets/homeService7-banner.png";
import Home3PaddingBanner from "../../assets/homeService7-banner-padding.png";
import Home3Padding from "../../assets/homeService7-padding.png";

import Home9 from "../../assets/homeService8.png";
import Home9Banner from "../../assets/homeService8-banner.png";
import Home9PaddingBanner from "../../assets/homeService8-banner-padding.png";
import Home9Padding from "../../assets/homeService8-padding.png";

import Home10 from "../../assets/homeService9.png";
import Home10Banner from "../../assets/homeService9-banner.png";

import EmptyIphoneServices from "../../assets/empty-iphone-services.png";

import { ADMIN_URL } from "../../utils/constants";
import { CircularProgress } from "@mui/material";
import { UserContext } from "../../context/UserContext";
import { useTranslation } from "react-i18next";
import { useAlert } from "react-alert";
import { useNavigate } from "react-router-dom";

import ShowcaseBanner from "../../assets/showcase-banner-services.png";
import ShowcaseBannerCategories from "../../assets/showcase-banner-services-2.png";
import ShowcaseBannerCategoriesPadding from "../../assets/showcase-banner-services-2-padding.png";
import ShowcaseNews from "../../assets/showcase-news-services.png";
import ShowcaseFeatured from "../../assets/showcase-featured-services.png";
import ShowcaseTabs from "../../assets/showcase-tabs-services.png";
import Tabbar from "../../assets/tabbar-ios-services.png";
import ShowcaseCategories1 from "../../assets/showcase-categories-services-1.png";
import ShowcaseCategories1Padding from "../../assets/showcase-categories-services-1-padding.png";
import ShowcaseCategories2 from "../../assets/showcase-categories-services-2.png";
import ShowcaseCategories3 from "../../assets/showcase-categories-services-3.png";
import ShowcaseCategories3Padding from "../../assets/showcase-categories-services-3-padding.png";
import ShowcaseCategories4 from "../../assets/showcase-categories-services-4.png";
import ShowcaseCategories5 from "../../assets/showcase-categories-services-5.png";
import ShowcaseCategories5Padding from "../../assets/showcase-categories-services-5-padding.png";
import ShowcaseCategories6 from "../../assets/showcase-categories-services-6.png";
import ShowcaseCategories6Padding from "../../assets/showcase-categories-services-6-padding.png";
import ShowcaseCategories7 from "../../assets/showcase-categories-services-7.png";
import ShowcaseCategories7Padding from "../../assets/showcase-categories-services-7-padding.png";
import ShowcaseCategories7Big from "../../assets/showcase-categories-services-7-big.png";
import ShowcaseCategories7BigPadding from "../../assets/showcase-categories-services-7-big-padding.png";
import ShowcaseCategories8 from "../../assets/showcase-categories-services-8.png";
import ShowcaseCategories8Padding from "../../assets/showcase-categories-services-8-padding.png";
import ShowcaseCategories8Big from "../../assets/showcase-categories-services-8-big.png";
import ShowcaseCategories8BigPadding from "../../assets/showcase-categories-services-8-big-padding.png";
import ShowcaseCategories9 from "../../assets/showcase-categories-services-9.png";

const useStyles = makeStyles({
	iphoneContainer: {
		"& *": {
			userDrag: "none",
		},
	},
	iphone: {
		width: 260,
		padding: 20,
		paddingTop: 0,
	},
	cardInfo: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
	},
	cardPageInfo: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
	},
	cardOptions: {
		display: "flex",
		flexDirection: "column",
	},
	cardForm: {
		display: "flex",
	},
	cardGrid: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
});

export default function HomeServices({
	drawerWidth,
	setRun,
	goToPublish,
	setGoToPublish,
}) {
	const classes = useStyles();
	const ref = useRef(); // We will use React useRef hook to reference the wrapping div:
	const { events } = useDraggable(ref); // Now we pass the reference to the useDraggable hook:
	const [home, setHome] = useState(null);
	const [showBanner, setShowBanner] = useState(null);
	const [showPadding, setShowPadding] = useState(true);
	const [showNew, setShowNew] = useState(null);
	const [showFeatured, setShowFeatured] = useState(null);
	const [showSearch, setShowSearch] = useState(null);
	const [loading, setLoading] = useState(false);
	const [homeProductType, setHomeProductType] = useState(null);
	const { user } = useContext(UserContext);
	const navigate = useNavigate();

	const alert = useAlert();

	const [backgroundColor, setBackgroundColor] = useState("#F9F9F9");
	const { t } = useTranslation();

	useEffect(() => {
		setRun(true);
	}, []);

	useEffect(() => {
		if (goToPublish) {
			setGoToPublish(false);
			navigate("/publish");
		}
	}, [goToPublish]);

	const getImage = () => {
		return EmptyIphoneServices;
	};

	const getHomeData = async () => {
		setLoading(true);
		try {
			const res = await axios.get(ADMIN_URL + "creators", {
				headers: { authorization: localStorage.getItem("token") },
			});
			setShowBanner(res.data.homeShowBanners);
			setShowPadding(res.data.homeShowPadding);
			setHomeProductType(res.data.homeProductType);
			setBackgroundColor(res.data.homeProductBackgroundColor);
			setShowNew(res.data.homeShowNews);
			setShowFeatured(res.data.homeShowFeatured);

			setHome(
				res.data.homeShowStickyHeader &&
					res.data.homeListType !== "rounded" &&
					res.data.homeProductType === "homeProduct4"
					? "home1"
					: res.data.homeShowStickyHeader &&
					  res.data.homeListType === "rounded" &&
					  res.data.homeProductType === "homeProduct4"
					? "home4"
					: res.data.homeProductType === "homeProduct5"
					? "home5"
					: res.data.homeProductType === "homeProduct6"
					? "home6"
					: res.data.homeProductType === "homeProduct2"
					? "home7"
					: res.data.homeProductType === "homeProduct3"
					? "home8"
					: !res.data.homeShowBigOverlayCarrousel &&
					  res.data.homeProductType === "homeProduct1"
					? "home3"
					: res.data.homeProductType === "homeProduct1"
					? "home9"
					: "home10"
			);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	useEffect(() => {
		getHomeData();
	}, []);

	useEffect(() => {
		getImage();
	}, [showBanner, home]);

	const saveHomeData = async () => {
		try {
			await axios.post(
				ADMIN_URL + "creators",
				{
					homeShowSearch: showSearch,
					homeShowStickyHeader:
						home === "home1" ||
						home === "home4" ||
						home === "home5" ||
						home === "home6" ||
						home === "home7" ||
						home === "home8"
							? true
							: false,
					homeShowBigCarrousel: home === "home3" ? true : false,
					homeShowBigOverlayCarrousel: home === "home9" ? true : false,
					homeShowBanners: showBanner,
					homeShowPadding: showPadding,
					homeProductType:
						home === "home4" || home === "home1" || home === "home10"
							? "homeProduct4"
							: home === "home5"
							? "homeProduct5"
							: home === "home6"
							? "homeProduct6"
							: home === "home7"
							? "homeProduct2"
							: home === "home8"
							? "homeProduct3"
							: "homeProduct1",
					homeProductBackgroundColor: backgroundColor,
					homeListType: home === "home4" ? "rounded" : "square",
					homeCategory: home === "home10" ? true : false,
					homeShowNews: showNew,
					homeShowFeatured: showFeatured,
				},
				{
					headers: { authorization: localStorage.getItem("token") },
				}
			);
			alert.show(t("general.success"), { type: "success" });
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<Box
			component="main"
			sx={{
				flexGrow: 1,
				bgcolor: "background.default",
				p: 3,
				width: { xs: "100%", sm: "calc(100vw - " + drawerWidth + "px)" },
			}}
		>
			<Toolbar />

			<Card variant="outlined">
				<>
					<CardContent>
						<Typography
							sx={{
								fontSize: 14,
								borderBottom: "1px solid #f0f0f0",
								minHeight: "35px",
								marginBottom: "20px",
								marginLeft: "-20px",
								marginRight: "-20px",
								padding: "0px 20px 20px",
							}}
							color="text.secondary"
							gutterBottom
						>
							{t("homeServices.title")}
						</Typography>
						<Box
							className={classes.cardPageInfo}
							sx={{
								flexFlow: {
									xs: "column-reverse",
									sm: "column-reverse",
									md: "row",
								},
							}}
						>
							<Box
								className={classes.cardOptions}
								sx={{
									minWidth: {
										xs: 0,
										sm: 0,
										md: 400,
									},
								}}
							>
								<RadioGroup
									aria-labelledby="demo-radio-buttons-group-label"
									value={home && home}
									name="radio-buttons-group"
									onChange={(e) => {
										setHome(e.target.value.toString());
										switch (e.target.value.toString()) {
											case "home4":
											case "home6":
											case "home10":
												setShowPadding(true);
												break;
										}
										if (ref.current) {
											setTimeout(() => {
												ref.current.scrollTo({
													top: ref.current.scrollHeight,
													behavior: "smooth",
												});
												setTimeout(() => {
													ref.current.scrollTo({
														top: 0,
														behavior: "smooth",
													});
												}, 500);
											}, 500);
										}
									}}
								>
									<FormControlLabel
										value="home1"
										control={
											<Radio
												id="home-style1"
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
										}
										label={t("homeServices.home1")}
										sx={{
											marginBottom: {
												xs: 1,
												sm: 1,
												md: 0,
											},
										}}
									/>
									<FormControlLabel
										value="home4"
										control={
											<Radio
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
										}
										label={t("homeServices.home4")}
										sx={{
											marginBottom: {
												xs: 1,
												sm: 1,
												md: 0,
											},
										}}
									/>
									<FormControlLabel
										value="home5"
										control={
											<Radio
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
										}
										label={t("homeServices.home5")}
										sx={{
											marginBottom: {
												xs: 1,
												sm: 1,
												md: 0,
											},
										}}
									/>
									<FormControlLabel
										value="home6"
										control={
											<Radio
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
										}
										label={t("homeServices.home6")}
										sx={{
											marginBottom: {
												xs: 1,
												sm: 1,
												md: 0,
											},
										}}
									/>
									<FormControlLabel
										value="home7"
										control={
											<Radio
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
										}
										label={t("homeServices.home7")}
										sx={{
											marginBottom: {
												xs: 1,
												sm: 1,
												md: 0,
											},
										}}
									/>
									<FormControlLabel
										value="home8"
										control={
											<Radio
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
										}
										label={t("homeServices.home8")}
										sx={{
											marginBottom: {
												xs: 1,
												sm: 1,
												md: 0,
											},
										}}
									/>
									<FormControlLabel
										value="home3"
										control={
											<Radio
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
										}
										label={t("homeServices.home3")}
										sx={{
											marginBottom: {
												xs: 1,
												sm: 1,
												md: 0,
											},
										}}
									/>
									<FormControlLabel
										value="home9"
										control={
											<Radio
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
										}
										label={t("homeServices.home9")}
										sx={{
											marginBottom: {
												xs: 1,
												sm: 1,
												md: 0,
											},
										}}
									/>
									<FormControlLabel
										value="home10"
										control={
											<Radio
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
										}
										label={t("homeServices.home10")}
										sx={{
											marginBottom: {
												xs: 1,
												sm: 1,
												md: 0,
											},
										}}
									/>
								</RadioGroup>
								<Typography
									sx={{
										fontSize: 12,
										marginTop: 2,
										marginBottom: 0,
										fontWeight: 700,
										textTransform: "uppercase",
									}}
									color="text.secondary"
									gutterBottom
								>
									{t("general.chooseOptions")}
								</Typography>

								<FormControlLabel
									control={
										<Checkbox
											checked={showBanner && showBanner}
											onChange={(e) => {
												setShowBanner(!showBanner);
											}}
											disabled={[
												"building",
												"built",

												"publishing",
												"published",
												"inviting",
											].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										/>
									}
									label={t("homeServices.showBanner")}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={showNew && showNew}
											onChange={(e) => {
												setShowNew(!showNew);
											}}
											disabled={[
												"building",
												"built",

												"publishing",
												"published",
												"inviting",
											].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										/>
									}
									label={t("home.showNewServices")}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={showFeatured && showFeatured}
											onChange={(e) => {
												setShowFeatured(!showFeatured);
											}}
											disabled={[
												"building",
												"built",

												"publishing",
												"published",
												"inviting",
											].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										/>
									}
									label={t("home.showFeaturedServices")}
								/>
								{home !== "home4" && home !== "home6" && home !== "home10" && (
									<FormControlLabel
										control={
											<Checkbox
												checked={showPadding && showPadding}
												onChange={(e) => {
													setShowPadding(!showPadding);
												}}
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
										}
										label={t("homeServices.addPadding")}
									/>
								)}

								{home === "home5" && (
									<>
										<FormControl
											fullWidth
											variant="standard"
											sx={{ marginTop: 4, marginBottom: 0 }}
										>
											<InputLabel
												shrink
												htmlFor="app-name-input"
												sx={{
													marginTop: -2,
													fontWeight: 700,
													textTransform: "uppercase",
													fontSize: 12,
												}}
											>
												{t("homeServices.backgroundColor")}
											</InputLabel>
											<TextField
												id="background-color"
												fullWidth
												variant="outlined"
												type="color"
												value={backgroundColor}
												onChange={(e) => {
													setBackgroundColor(e.target.value);
												}}
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
											<Box
												sx={{
													backgroundColor: backgroundColor,
													position: "absolute",
													top: "12px",
													left: "12px",
													width: "calc(100% - 24px)",
													height: "16px",
													outline: "1px solid",
													pointerEvents: "none",
													borderRadius: "2px",
												}}
											></Box>
										</FormControl>
										<Typography
											sx={{
												fontWeight: 500,
												fontSize: 11,
												marginTop: 1,
											}}
										>
											{t("general.changeInApp")}
										</Typography>
									</>
								)}
							</Box>
							<div
								className={classes.iphoneContainer}
								style={{ position: "relative" }}
							>
								<img
									src={getImage()}
									alt="iphone"
									onMouseOver={() => {}}
									onMouseLeave={() => {}}
									className={classes.iphone}
									draggable={false}
								/>

								<Box
									sx={{
										position: "absolute",
										top: 0,
										bottom: 0,
										padding:
											"53.75px 29px 72.25px 30px" /*"55.25px 29px 73px 30.25px",*/,
										width: 260,
										zIndex: 2,
									}}
									draggable={false}
								>
									<Box
										id="showcase"
										sx={{
											width: "100%",
											aspectRatio: "220 / 386.5",
											overflow: "auto",
											display: "flex",
											flexDirection: "column",
										}}
										{...events}
										ref={ref}
									>
										{
											showBanner &&
												/*home === "home2" ? (
												showSearch ? (
													showPadding ? (
														<img
															src={ShowcaseBannerSearchCarousel1Padding}
															style={{ width: "100%" }}
														/>
													) : (
														<img
															src={ShowcaseBannerSearchCarousel1}
															style={{ width: "100%" }}
														/>
													)
												) : showPadding ? (
													<img
														src={ShowcaseBannerCarousel1Padding}
														style={{ width: "100%" }}
													/>
												) : (
													<img
														src={ShowcaseBannerCarousel1}
														style={{ width: "100%" }}
													/>
												)
											) : home === "home3" ? (
												showSearch ? (
													showPadding ? (
														<img
															src={ShowcaseBannerSearchCarousel2Padding}
															style={{ width: "100%" }}
														/>
													) : (
														<img
															src={ShowcaseBannerSearchCarousel2}
															style={{ width: "100%" }}
														/>
													)
												) : showPadding ? (
													<img
														src={ShowcaseBannerCarousel2Padding}
														style={{ width: "100%" }}
													/>
												) : (
													<img
														src={ShowcaseBannerCarousel2}
														style={{ width: "100%" }}
													/>
												)
											) :*/ (home === "home3" && showPadding ? (
													<img
														alt="showcase-banner-services-2-padding"
														src={ShowcaseBannerCategoriesPadding}
														style={{ width: "100%" }}
														draggable={false}
													/>
												) : home === "home3" ? (
													<img
														alt="showcase-banner-services-2"
														src={ShowcaseBannerCategories}
														style={{ width: "100%" }}
														draggable={false}
													/>
												) : home === "home9" && showPadding ? (
													<img
														alt="showcase-banner-services-2-padding"
														src={ShowcaseBannerCategoriesPadding}
														style={{ width: "100%" }}
														draggable={false}
													/>
												) : home === "home9" ? (
													<img
														alt="showcase-banner-services-2"
														src={ShowcaseBannerCategories}
														style={{ width: "100%" }}
														draggable={false}
													/>
												) : (
													<img
														alt="showcase-banner"
														src={ShowcaseBanner}
														style={{ width: "100%" }}
														draggable={false}
													/>
												)) /* : null*/
										}
										{showNew && (
											<img
												alt="showcase-news"
												src={ShowcaseNews}
												style={{ width: "100%" }}
												draggable={false}
											/>
										)}
										{showFeatured && (
											<img
												alt="showcase-featured"
												src={ShowcaseFeatured}
												style={{ width: "100%" }}
												draggable={false}
											/>
										)}
										{/*showCategories && (
											<img src={ShowcaseCategories} style={{ width: "100%" }} />
										)*/}
										{/*<Box
											sx={{
												width: "100%",
												padding: 1,
												backgroundColor: "white",
											}}>
											<Typography sx={{ fontSize: 8 }}>FEATURED</Typography>
											<Box
												sx={{
													backgroundColor: "#efefef",
													height: 40,
												}}></Box>
											</Box>*/}
										{[
											"home1",
											"home4",
											"home5",
											"home6",
											"home7",
											"home8",
										].find((h) => h === home) && (
											<img
												alt="showcase-tabs"
												src={ShowcaseTabs}
												style={{ width: "100%" }}
												draggable={false}
											/>
										)}
										{home === "home1" ? (
											showPadding ? (
												<img
													alt="showcase-categories-1-padding"
													src={ShowcaseCategories1Padding}
													style={{ width: "100%" }}
													draggable={false}
												/>
											) : (
												<img
													alt="showcase-categories-1"
													src={ShowcaseCategories1}
													style={{ width: "100%" }}
													draggable={false}
												/>
											)
										) : home === "home4" ? (
											<img
												alt="showcase-categories-2"
												src={ShowcaseCategories2}
												style={{ width: "100%" }}
												draggable={false}
											/>
										) : home === "home5" ? (
											showPadding ? (
												<img
													alt="showcase-categories-3-padding"
													src={ShowcaseCategories3Padding}
													style={{ width: "100%" }}
													draggable={false}
												/>
											) : (
												<img
													alt="showcase-categories-3"
													src={ShowcaseCategories3}
													style={{ width: "100%" }}
													draggable={false}
												/>
											)
										) : home === "home6" ? (
											<img
												alt="showcase-categories-4"
												src={ShowcaseCategories4}
												style={{ width: "100%" }}
												draggable={false}
											/>
										) : home === "home7" ? (
											showPadding ? (
												<img
													alt="showcase-categories-5-padding"
													src={ShowcaseCategories5Padding}
													style={{ width: "100%" }}
													draggable={false}
												/>
											) : (
												<img
													alt="showcase-categories-5"
													src={ShowcaseCategories5}
													style={{ width: "100%" }}
													draggable={false}
												/>
											)
										) : home === "home8" ? (
											showPadding ? (
												<img
													alt="showcase-categories-6-padding"
													src={ShowcaseCategories6Padding}
													style={{ width: "100%" }}
													draggable={false}
												/>
											) : (
												<img
													alt="showcase-categories-6"
													src={ShowcaseCategories6}
													style={{ width: "100%" }}
													draggable={false}
												/>
											)
										) : home === "home3" ? (
											!showBanner ? (
												showPadding ? (
													<img
														alt="showcase-categories-7-big-padding"
														src={ShowcaseCategories7BigPadding}
														style={{ width: "100%" }}
														draggable={false}
													/>
												) : (
													<img
														alt="showcase-categories-7-big"
														src={ShowcaseCategories7Big}
														style={{ width: "100%" }}
														draggable={false}
													/>
												)
											) : showPadding ? (
												<img
													alt="showcase-categories-7-padding"
													src={ShowcaseCategories7Padding}
													style={{ width: "100%" }}
													draggable={false}
												/>
											) : (
												<img
													alt="showcase-categories-7"
													src={ShowcaseCategories7}
													style={{ width: "100%" }}
													draggable={false}
												/>
											)
										) : home === "home9" ? (
											!showBanner ? (
												showPadding ? (
													<img
														alt="showcase-categories-8-big-padding"
														src={ShowcaseCategories8BigPadding}
														style={{ width: "100%" }}
														draggable={false}
													/>
												) : (
													<img
														alt="showcase-categories-8-big"
														src={ShowcaseCategories8Big}
														style={{ width: "100%" }}
														draggable={false}
													/>
												)
											) : showPadding ? (
												<img
													alt="showcase-categories-8-padding"
													src={ShowcaseCategories8Padding}
													style={{ width: "100%" }}
													draggable={false}
												/>
											) : (
												<img
													alt="showcase-categories-8"
													src={ShowcaseCategories8}
													style={{ width: "100%" }}
													draggable={false}
												/>
											)
										) : home === "home10" ? (
											<img
												alt="showcase-categories-9"
												src={ShowcaseCategories9}
												style={{ width: "100%" }}
												draggable={false}
											/>
										) : null}
										{/*home === "home2" ? (
											showBanner ? (
												showSearch ? (
													showPadding ? (
														<img
															src={
																ShowcaseCategoriesCarousel1BannerSearchPadding
															}
															style={{ width: "100%" }}
														/>
													) : (
														<img
															src={ShowcaseCategoriesCarousel1BannerSearch}
															style={{ width: "100%" }}
														/>
													)
												) : showPadding ? (
													<img
														src={ShowcaseCategoriesCarousel1BannerPadding}
														style={{ width: "100%" }}
													/>
												) : (
													<img
														src={ShowcaseCategoriesCarousel1Banner}
														style={{ width: "100%" }}
													/>
												)
											) : showSearch ? (
												showPadding ? (
													<img
														src={ShowcaseCategoriesCarousel1SearchPadding}
														style={{ width: "100%" }}
													/>
												) : (
													<img
														src={ShowcaseCategoriesCarousel1Search}
														style={{ width: "100%" }}
													/>
												)
											) : showPadding ? (
												<img
													src={ShowcaseCategoriesCarousel1Padding}
													style={{ width: "100%" }}
												/>
											) : (
												<img
													src={ShowcaseCategoriesCarousel1}
													style={{ width: "100%" }}
												/>
											)
										) : home === "home3" ? (
											showBanner ? (
												showSearch ? (
													showPadding ? (
														<img
															src={
																ShowcaseCategoriesCarousel2BannerSearchPadding
															}
															style={{ width: "100%" }}
														/>
													) : (
														<img
															src={ShowcaseCategoriesCarousel2BannerSearch}
															style={{ width: "100%" }}
														/>
													)
												) : showPadding ? (
													<img
														src={ShowcaseCategoriesCarousel2BannerPadding}
														style={{ width: "100%" }}
													/>
												) : (
													<img
														src={ShowcaseCategoriesCarousel2Banner}
														style={{ width: "100%" }}
													/>
												)
											) : showSearch ? (
												showPadding ? (
													<img
														src={ShowcaseCategoriesCarousel2SearchPadding}
														style={{ width: "100%" }}
													/>
												) : (
													<img
														src={ShowcaseCategoriesCarousel2Search}
														style={{ width: "100%" }}
													/>
												)
											) : showPadding ? (
												<img
													src={ShowcaseCategoriesCarousel2Padding}
													style={{ width: "100%" }}
												/>
											) : (
												<img
													src={ShowcaseCategoriesCarousel2}
													style={{ width: "100%" }}
												/>
											)
											) : null*/}
									</Box>
								</Box>

								<img
									src={Tabbar}
									alt="tabbar"
									onMouseOver={() => {}}
									onMouseLeave={() => {}}
									className={classes.iphone}
									style={{ position: "absolute", top: 0, left: 0 }}
									draggable={false}
								/>
							</div>
						</Box>
					</CardContent>
					{!["building", "built", "publishing"].find(
						(status) =>
							status ===
							(user.app.appStatuses.length === 0
								? ""
								: user.app.appStatuses.length > 0 &&
								  user.app.appStatuses[0].status)
					) && (
						<CardActions sx={{ justifyContent: "right" }}>
							<Button
								variant="contained"
								size="small"
								onClick={saveHomeData}
								disabled={loading}
							>
								{loading ? <CircularProgress size={12} /> : t("general.save")}
							</Button>
						</CardActions>
					)}
				</>
			</Card>
		</Box>
	);
}
